import { FormControl, FormGroup } from '@angular/forms';
import { ReportFilterDto } from '../../../../../../../types/dtos/reports.dto';
import { BaseFilterStep } from '../base-filter-step';

export class FilterLogStep extends BaseFilterStep {

  public form: FormGroup = new FormGroup({
    userSelect: new FormControl(),
    actionSelect: new FormControl(),
    targetSelect: new FormControl(),
    deviceSelect: new FormControl(),
  });

  getStepFilter(): ReportFilterDto {
    const {
      userSelect,
      actionSelect,
      targetSelect,
      deviceSelect
    } = this.form.value;

    return {
      filter: {
        account_id: userSelect ? Number(userSelect) : undefined,
        action: actionSelect ?? undefined,
        target: targetSelect ?? undefined,
        target_id: deviceSelect ? Number(deviceSelect) : undefined
      }
    };
  }

  getForm(): FormGroup {
    return this.form;
  }
}
